var quickMacroize = require("enyo/macroize").quickMacroize;

/**
 * Authenticate user and redirect to login page if they are not logged in.
 *
 * @param    {app.core.RouteHandler}  routeHandler  The route handler
 * @param    {app.App}                app           The application instance
 * @returns  {Promise}                A promise that resolves once the task is
 *                                    done.
 */
module.exports = function(routeHandler, app) {

    // First check current login status
    return new Promise(function(resolve) {
        var $authService = app.$.authService,
            isLoggedIn   = $authService.isLoggedIn,
            onAuthResult;

        // Login status is known, resolve immediately
        if (isLoggedIn === -1 || isLoggedIn === 1) {
            resolve(isLoggedIn);

            return;
        }

        // Handler for authentication result
        onAuthResult = function() {
            $authService.off("Auth::loggedIn", onAuthResult);
            $authService.off("Auth::loggedOut", onAuthResult);
            resolve($authService.isLoggedIn);
        };

        // Await pending authentication result
        $authService.on("Auth::loggedIn", onAuthResult);
        $authService.on("Auth::loggedOut", onAuthResult);
    })

        // Then redirect to login page if user is not logged in
        .then(function(isLoggedIn) {
            var $i18nService = app.$.i18nService,
                $router      = app.$.router,
                language     = $i18nService.get("language"),
                redirectPath;

            if (!routeHandler.finished && isLoggedIn !== 1) {
                routeHandler.finish();

                redirectPath = $router.getCurrentPath() || "";
                redirectPath = "/" + redirectPath.replace(/^\/+/, "");
                redirectPath = encodeURIComponent(redirectPath);

                $router.navigate(quickMacroize("/{$language}/login/{$redirectPath}", {
                    language:     language,
                    redirectPath: redirectPath
                }));
            }

            return Promise.resolve();
        });
};
